<template>
  <div class="con-dialog" v-show="diaShow">
    <div class="con-box">
      <div class="dia-box">
        <div class="box-header">
          <div class="box-header-tit"></div>
          <div class="box-header-tit" style="color: #cbcbcb;">{{ title }}</div>
          <div class="box-header-close" @click="diaShowClose" style="color: #cbcbcb;">X</div>
        </div>
        <div class="box-body">
          <div class="box-body-fj">
            <div class="box-body-fj-img" :style="{ 'background-image': fjImagesrc }">
              <!-- 蒙版深度 -->
              <div class="mask-box"></div>
              <!-- 风机旋转模板 -->
              <div class="container">
                <div :class="animaOne">
                  <div class="petal" style="--i:1"></div>
                  <div class="petal" style="--i:2"></div>
                  <div class="petal" style="--i:3"></div>
                  <div class="petal" style="--i:4"></div>
                  <div class="petal" style="--i:5"></div>
                  <div class="petal" style="--i:6"></div>
                  <div class="petal" style="--i:7"></div>
                  <div class="petal" style="--i:8"></div>
                </div>
              </div>
              <div class="container1">
                <div :class="animaTwo">
                  <div class="petal1" style="--i:1"></div>
                  <div class="petal1" style="--i:2"></div>
                  <div class="petal1" style="--i:3"></div>
                  <div class="petal1" style="--i:4"></div>
                  <div class="petal1" style="--i:5"></div>
                  <div class="petal1" style="--i:6"></div>
                  <div class="petal1" style="--i:7"></div>
                  <div class="petal1" style="--i:8"></div>
                </div>
              </div>
              <!-- 树形 -->
              <div class="tree-box"></div>
              <!-- 报警提示 -->
              <div class="police-box"></div>
              <!-- 水箱效果 -->
              <div class="water-box"></div>
              <!-- --参数设定-- -->
              <div class="parameter-data">
                <div style="font-size: 10px;color: #bebebe;">参数设置</div>
                <div style="width: 100%;justify-content: flex-start;;padding-top: 0px;padding-top: 0px;">
                  <input v-model="temp" /><span>℃</span>
                </div>
                <div style="width: 100%;justify-content: flex-start;margin-top: 5px;padding-top: 0px;">
                  <input v-model="humd" /><span>%Rh</span>
                </div>
                <div style="width: 100%;justify-content: flex-start;margin-top: 5px;padding-top: 0px;">
                  <input v-model="ratio" /><span>Hz</span>
                </div>
              </div>
              <div class="pos-abs" style="top: 150px;left: 20px;">
                <span>新风量</span>
                <div style="width: 100px;justify-content: flex-start;margin-top: 5px;padding-top: 0px;">
                  <input v-model="freshAirData" @change="updateFreshData" /><span>%</span>
                </div>
              </div>
              <!--  风机数据 -->
              <div class="pos-abs" style="top: 101px;left: 444px;">
                <span style="color: #ACC9A3;">22.5℃</span><br>
                <span style="color: #ACC9A3;">30.2%RH</span>
              </div>
              <div class="pos-abs" style="top: 230px;left: 558px;">
                <span style="color: #ACC9A3;">22.5℃</span><br>
                <span style="color: #ACC9A3;">30.2%RH</span>
              </div>
              <div class="pos-abs" style="top: 227px;left: 204px;">
                <span style="color: #ACC9A3;">22.5℃</span><br>
                <span style="color: #ACC9A3;">30.2%RH</span>
              </div>
              <div class="pos-abs" style="top: 239px;left: 470px;">
                <span style="color: #C88E6D;">45.3Hz</span><br>
              </div>
              <div class="pos-abs" style="top: 113px;left: 165px;">
                <span style="color: #C88E6D;">45.3Hz</span><br>
              </div>
              <div class="pos-abs" style="top: 313px;left: 432px;">
                <span style="color: #ACC9A3;">50%</span><br>
              </div>
              <!-- 机组启停 -->
              <div class="pos-abs" style="text-align: center;width: 90px;top: 154px;right: 40px;">
                <div class="content-switch" :style="{ 'background-image': switchImgSrc }"></div>
                <span>机组启停</span>
              </div>

              <!-- 阀门角度 -->
              <div class="bar-box1">
                <div class="bar-box1-fa1" :style="{ 'transform': transformBar1 }">
                </div>
                <div class="bar-box1-fa2 flex" :style="{ 'transform': transformBar1 }">
                </div>
                <div class="bar-box1-fa3 flex" :style="{ 'transform': transformBar1 }">
                </div>
              </div>
              <div class="bar-box2">
                <div class="bar-box1-fa1" :style="{ 'transform': transformBar2 }">
                </div>
                <div class="bar-box1-fa2 flex" :style="{ 'transform': transformBar2 }">
                </div>
                <div class="bar-box1-fa3 flex" :style="{ 'transform': transformBar2 }">
                </div>
              </div>
              <!-- 饼状图 -->
              <div class="pie-box">
                <div style="width: 100%;height: 100%;" ref="pie"></div>
              </div>
              <!-- 柱状图 -->
              <div class="bar-box4">
                <div style="width: 100%;height: 100%;" ref="bar4"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
export default {
  name: '',
  props: {
    dialogtwoshow: {
      type: Boolean,
    }
  },
  data() {
    return {
      temp: '0',
      humd: '0',
      ratio: '0',
      freshAirData: '0',
      title: 'K-B1-1-B119',
      animaOne: 'loaderOn',
      animaTwo: 'loader1On',
      diaShow: false,
      fjImagesrc: 'url(../../../../static/img/lengdongzhan/022.gif)',
      switchImgSrc: 'url(../../../static/img/tencent/off.png)',
      transformBar1: 'rotate(0deg)',
      transformBar2: 'rotate(0deg)',
      pieData: '30',
      bar1Data: '0',
      bar2Data: "0",
      bar3Data: '60',
    };
  },

  components: {},

  computed: {},

  beforeMount() { },

  mounted() {
    this.$nextTick(function () {
      this.echartsDrawLine();
    });
  },
  created() {
    if (window.Notification) {
      // 浏览器通知--window.Notification 
      if (Notification.permission == "granted") {
        console.log("允许通知")
      } else if (Notification.permission != "denied") {
        console.log("需要通知权限")
        Notification.requestPermission((permission) => { });
      }
    } else {
      console.error('浏览器不支持Notification');
    }

  },
  methods: {
    //饼状图加载 
    echartsDrawLine() {
      let pieOne = echarts.init(this.$refs.pie);
      pieOne.setOption(
        {
          tooltip: {
            show: false,
            trigger: 'item'
          },
          color: ['#909090', '#cd9078'],
          grid: {
            left: '0%',
            right: '0%',
            top: '0%',
            bottom: '0%',
          },
          legend: {
            show: false,
            orient: 'vertical',
            left: 'left'
          },
          series: [
            {
              name: 'Access From',
              type: 'pie',
              radius: '23%',
              data: [
                { value: this.bar3Data, name: 'Search Engine' },
                { value: this.pieData, name: 'Direct' },
              ],
              label: {
                normal: {
                  show: false
                },
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              emphasis: {
                itemStyle: {
                  show: false,
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieOne.resize()
      })
      let bar4 = echarts.init(this.$refs.bar4);
      bar4.setOption(
        {
          color: ['#c26a3b73'],
          grid: {
            left: '0%',
            right: '15%',
            top: '0%',
            bottom: '25%',
          },
          xAxis: {
            show: false,
            type: 'category',
            data: ['Mon']
          },
          yAxis: {
            show: false,
            type: 'value',
            min: 0,
            max: 100,
          },
          series: [
            {
              data: [50],
              type: 'bar',
              barWidth: '30%',
              showBackground: true,
              backgroundStyle: {
                color: '#2b2b2b6b'
              },
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        bar4.resize()
      })
    },
    diaShowClose() {
      this.diaShow = false
      this.$emit('dialogTwoClose', false)
    },
    // 改变新风量的值
    updateFreshData() {
      this.pieData = this.freshAirData
      this.bar1Data = this.freshAirData
      this.bar2Data = this.freshAirData
      this.bar3Data = 90 - this.freshAirData
      this.transformBar1 = `rotate(${this.freshAirData}deg)`
      this.transformBar2 = `rotate(${this.freshAirData}deg)`
      this.echartsDrawLine()
    },
    openShow() {
      this.diaShow = true
    }
  },

  watch: {
    dialogtwoshow: {
      handler(newVal, oldVal) {
        this.diaShow = newVal
      }
    }
  }

}

</script>
<style scoped>
.content-switch {
  width: 20px;
  height: 20px;
  background-size: 100% 100%;
  margin-left: 35px;
  cursor: pointer;
}

.pos-abs {
  position: absolute;
  z-index: 99;
}

span {
  color: #bebebe;
  margin-left: 5px;
  font-size: 10px;
}

input {
  width: 40%;
  background-color: transparent;
  padding-top: 0;
  color: #bebebe;
  font-size: 10px;
}

input:focus {
  outline: none;
  border: 2px solid #6f6f6f;
}

.con-dialog {
  position: relative;
  z-index: 33;
  width: 100%;
  height: 100%;
}

.con-box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dia-box {
  width: 700px;
  height: 400px;
  background: radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%);
  border-radius: 10px;
  border: 1px solid #6fa5de;
  box-shadow: 0px 0px 8px #A3CBF2;
}

.box-header {
  border-radius: 5px 5px 0 0;
  width: 100%;
  height: 27px;
  background-image: url('../../../../static/img/fisheries/003.png');
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  box-sizing: border-box;
  padding: 0px 5px 7px 20px;
}

.box-header-close {
  width: 20px;
  height: 20px;
  background-size: 100% 100%;
  cursor: pointer;
}

.box-body {
  width: 100%;
  height: 90%;
  box-sizing: border-box;
  flex-wrap: wrap;
}

.box-body-fj {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box-body-fj-img {
  width: 724px;
  height: 373px;
  background-size: 100% 100%;
  position: relative;
}

.mask-box {
  position: absolute;
  z-index: 99;
  width: 100%;
  height: 97%;
  top: 8px;
  background: radial-gradient(ellipse at bottom, #1b2735a9 0%, #090a0f96 100%);
  z-index: 9;
}

.container {
  position: absolute;
  width: 5vh;
  height: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: animate_container 2s linear 1 forwards;
  left: 470px;
  top: 225px;
}

.container1 {
  position: absolute;
  width: 5vh;
  height: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: animate_container 2s linear 1 forwards;
  left: 165px;
  top: 99px;
}

.petal {
  position: absolute;
  width: 40%;
  height: 20%;
  /* background-color: blueviolet; */
  border: .5vh solid #cbcbcb;
  box-shadow: 0 0 10vh #cbcbcb;
  border-radius: 0 10vh 0 10vh;
  transform: rotate(calc(var(--i) * 45deg)) translateY(2.5vh);
  animation: animate_petal 1.6s linear infinite;
  animation-delay: calc(var(--i) * 200ms);
}

.petal1 {
  position: absolute;
  width: 40%;
  height: 20%;
  /* background-color: blueviolet; */
  border: .5vh solid #cbcbcb;
  box-shadow: 0 0 10vh #cbcbcb;
  border-radius: 10vh 0 10vh;
  transform: rotate(calc(var(--i) * 45deg)) translateY(2.5vh);
  animation: animate_petal 1.6s linear infinite;
  animation-delay: calc(var(--i) * 200ms);
  color: #575757;
}

@keyframes animate_petal {
  0% {
    border: .5vh solid #cbcbcb;
    box-shadow: 0 0 10vh #cbcbcb;
  }

  50% {
    border: .5vh solid #cbcbcb;
    box-shadow: 0 0 10vh #cbcbcb;
  }

  100% {
    border: .5vh solid #cbcbcb;
    box-shadow: 0 0 10vh #cbcbcb;
  }
}

.loader {
  position: absolute;
  width: 5vh;
  height: 5vh;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  /* animation: animate_loader 1s linear infinite; */
  animation: none;
}

.loaderOn {
  position: absolute;
  width: 5vh;
  height: 5vh;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: animate_loader 1s linear infinite;
}

.loader1 {
  position: absolute;
  width: 5vh;
  height: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  /* animation: animate_loader1 1s linear infinite; */
  animation: none;
}

.loader1On {
  position: absolute;
  width: 5vh;
  height: 5vh;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: animate_loader1 1s linear infinite;
}


@keyframes animate_loader {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes animate_loader1 {
  0% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

/**参数设定 */
.parameter-data {
  position: absolute;
  width: 100px;
  height: 92px;
  top: 50px;
  right: 5px;
  z-index: 99;
  text-align: left;
}

/**阀门角度 */
.bar-box1 {
  position: absolute;
  width: 5px;
  height: 83px;
  top: 80px;
  left: 112px;
  z-index: 10;
}

.bar-box2 {
  position: absolute;
  width: 5px;
  height: 83px;
  top: 210px;
  left: 112px;
  z-index: 10;
}

.bar-box1-fa1 {
  position: absolute;
  width: 10px;
  height: 26px;
  top: 0;
  left: -2px;
  z-index: 10;
  background-image: url(../../../../static/img/lengdongzhan/fa.png);
  background-size: 100% 100%;
}

.bar-box1-fa2 {
  position: absolute;
  width: 10px;
  height: 25px;
  top: 28px;
  left: -2px;
  z-index: 10;
  background-image: url(../../../../static/img/lengdongzhan/fa.png);
  background-size: 100% 100%;
}

.bar-box1-fa3 {
  position: absolute;
  width: 10px;
  height: 25px;
  top: 56px;
  left: -2px;
  z-index: 10;
  background-image: url(../../../../static/img/lengdongzhan/fa.png);
  background-size: 100% 100%;
}

/* 树形 */
.tree-box {
  position: absolute;
  z-index: 10;
  width: 5px;
  height: 29px;
  background-color: #515860;
  left: 432px;
  top: 284px;
}

/**报警框 */
.police-box {
  position: absolute;
  width: 20px;
  height: 72px;
  top: 213px;
  left: 175px;
  background-color: #ff00003e;
  animation: fade-data-v-582296d4 .6s infinite;
  -webkit-animation: fade-data-v-582296d4 .6s infinite;
  z-index: 10;
}

/**水箱效果 */
.water-box {
  position: absolute;
  width: 10px;
  height: 71px;
  top: 213px;
  left: 430px;
  background-color: #009dff45;
  animation: fade-data-v-582296d4 .6s infinite;
  -webkit-animation: fade-data-v-582296d4 .6s infinite;
  z-index: 10;
}

/**饼状图 */
.pie-box {
  position: absolute;
  width: 50px;
  height: 70px;
  left: 65px;
  top: 134px;
  z-index: 99;
}

.bar-box4 {
  position: absolute;
  width: 20px;
  height: 90px;
  top: 198px;
  left: 418px;
  z-index: 10;
  transform: rotate(180deg);
}
</style>


// WEBPACK FOOTER //
// src/components/graphically/dialog/fantwo.vue